// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center---wY_Rd {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.hidden---lHYNm {
  display: none !important;
}
.header---fWSyK {
  position: sticky;
  top: 0;
  width: 100%;
  height: 54px;
  display: flex;
  background: #ffffff;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.13);
  z-index: 1;
}
.headerWithDesc---XExbg {
  display: block;
  height: 100%;
  padding-top: 13px;
}
.main---UBCw6 {
  margin: 0 auto;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 36px;
  display: flex;
  flex-flow: column;
}
.main---UBCw6.default---M4SL2 {
  width: 937px;
}
.main---UBCw6.tiktok---gXbgE {
  width: 1170px;
}
.navWrapper---bmk3v {
  width: 100%;
}
.navSmall---KvGH8 {
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-left: 9px;
  padding-right: 9px;
  width: 937px;
  justify-content: space-between;
}
.navSmall---KvGH8.default---M4SL2 {
  width: 937px;
}
.navSmall---KvGH8.tiktok---gXbgE {
  width: 1170px;
}
.navLarge---P4rhy {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 36px 71px 20px 71px;
}
.tiles---aOdW7 {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.loading---a6IC7 {
  width: 100%;
  font-size: 16px;
  line-height: 40px;
}
@media (max-width: 991.98px) {
  .navSmall---KvGH8,
  .topNav---nbzht,
  .header---fWSyK {
    width: 100%;
  }
  .headerWithDesc---XExbg {
    min-height: 83px;
    display: inline-table;
  }
  .main---UBCw6 {
    width: inherit !important;
    padding-bottom: 20px;
  }
  .mainWithoutDisplayText---UddyT {
    padding-top: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app.less"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AACF;AACA;EACE,wBAAA;AACF;AAEA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EAEA,mBAAA;EACA,2CAAA;EACA,UAAA;AADF;AAGA;EACE,cAAA;EACA,YAAA;EACA,iBAAA;AADF;AAIA;EA1BE,cAAA;EAEA,mBAAA;EACA,8BAAA;EAyBA,oBAAA;EACA,aAAA;EACA,iBAAA;AAAF;AAEE;EACE,YAAA;AAAJ;AAGE;EACE,aAAA;AADJ;AAKA;EACE,WAAA;AAHF;AAKA;EA5CE,cAAA;EACA,aAAA;EACA,mBAAA;EA6CA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;AAFF;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,aAAA;AAHJ;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;AAJF;AAOA;EACE,WAAA;EACA,aAAA;EACA,eAAA;AALF;AAQA;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AANF;AAUA;EACE;;;IAGE,WAAA;EARF;EAUA;IACE,gBAAA;IACA,qBAAA;EARF;EAUA;IACE,yBAAA;IACA,oBAAA;EARF;EAUA;IACE,iBAAA;EARF;AACF","sourcesContent":[".center {\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.hidden {\n  display: none !important;\n}\n\n.header {\n  position: sticky;\n  top: 0;\n  width: 100%;\n  height: 54px;\n  display: flex;\n\n  background: #ffffff;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.13);\n  z-index: 1;\n}\n.headerWithDesc {\n  display: block;\n  height: 100%;\n  padding-top: 13px;\n}\n\n.main {\n  .center;\n  padding-bottom: 36px;\n  display: flex;\n  flex-flow: column;\n\n  &.default {\n    width: 937px;\n  }\n\n  &.tiktok {\n    width: 1170px;\n  }\n}\n\n.navWrapper {\n  width: 100%;\n}\n.navSmall {\n  display: flex;\n  .center;\n  padding-left: 9px;\n  padding-right: 9px;\n  width: 937px;\n  justify-content: space-between;\n\n  &.default {\n    width: 937px;\n  }\n\n  &.tiktok {\n    width: 1170px;\n  }\n}\n.navLarge {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 36px 71px 20px 71px;\n}\n\n.tiles {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.loading {\n  width: 100%;\n  font-size: 16px;\n  line-height: 40px;\n}\n\n// Medium devices (tablets, less than 992px)\n@media (max-width: 991.98px) {\n  .navSmall,\n  .topNav,\n  .header {\n    width: 100%;\n  }\n  .headerWithDesc {\n    min-height: 83px;\n    display: inline-table;\n  }\n  .main {\n    width: inherit !important;\n    padding-bottom: 20px;\n  }\n  .mainWithoutDisplayText {\n    padding-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"center": `center---wY_Rd`,
	"hidden": `hidden---lHYNm`,
	"header": `header---fWSyK`,
	"headerWithDesc": `headerWithDesc---XExbg`,
	"main": `main---UBCw6`,
	"default": `default---M4SL2`,
	"tiktok": `tiktok---gXbgE`,
	"navWrapper": `navWrapper---bmk3v`,
	"navSmall": `navSmall---KvGH8`,
	"navLarge": `navLarge---P4rhy`,
	"tiles": `tiles---aOdW7`,
	"loading": `loading---a6IC7`,
	"topNav": `topNav---nbzht`,
	"mainWithoutDisplayText": `mainWithoutDisplayText---UddyT`
};
export default ___CSS_LOADER_EXPORT___;
